import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import {reducer as toastrReducer} from 'react-redux-toastr';

const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    toastr: toastrReducer,
});
export default createRootReducer
